import type { SceneHandle } from "../three/scene";

// Module-level accessor so HUD overlays (damage numbers, etc.) can reach the
// live scene handle without prop-drilling through React state. The scene is
// created/destroyed in App's effect; this just mirrors it.
let current: SceneHandle | null = null;

export function setSceneHandle(handle: SceneHandle | null): void {
  current = handle;
}

export function getSceneHandle(): SceneHandle | null {
  return current;
}
